<div class="container-xxl">
  <div class="row">
    <div class="wrapper">
      <mb-media
        *ngIf="media"
        [media]="media"
        [autoplay]="true"
        [muted]="true"
        [controls]="false"
        [loop]="true"
        [hideTitles]="true"
        [playsInline]="true"
      ></mb-media>
      <div class="content-outer">
        <div *ngIf="titleHash" class="title-hash-container">
          <span>{{ titleHash }}</span>
        </div>

        <div class="content-inner">
          <div *ngIf="title" class="title-container">
            <span class="font-family-title" [innerHTML]="title"></span>
          </div>
          <div *ngIf="links?.length" class="button-container">
            <ng-container *ngFor="let item of links">
              <a *ngIf="item.label" [routerLink]="[item.link]" [queryParams]="item.queryParams || {}" class="btn">
                {{ item.label }}
              </a>
            </ng-container>
          </div>

          <div *ngIf="subtitle" class="subtitle-container" [innerHTML]="subtitle"></div>
          <div *ngIf="fuelLabel" class="fuel-label-container copy-s">
            <p class="copy-s" [innerHTML]="fuelLabel"></p>
          </div>
        </div>
      </div>

      <div *ngIf="teasers?.length && !hideAnnouncements" class="row announcements">
        <mb-announcement
          *ngFor="let teaser of teasers"
          class="col"
          [title]="teaser.title"
          [subtitle]="teaser.subtitle"
          [countdownDate]="teaser.countdownDate"
          [countdownLabel]="teaser.countdownLabel"
          [postCountdownLabel]="teaser.postCountdownLabel"
          [showDaysOnly]="teaser.showDaysOnly"
          [isBelowCountdown]="isBelowCountdown"
        ></mb-announcement>
      </div>
    </div>
  </div>
</div>
